module.exports = __webpack_public_path__ + "img/rollie_cpg.58904d60.jpg";